import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
} from "@mui/material";
import React from "react";

const YesNo_modal = (props) => {
    const close_handler = () => {
        props.close();
    };

    const delete_handler = () => {
        props.delete(props.id);
    };

    return (
        <Dialog
            open={true}
            onClose={close_handler}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: { xs: 0, sm: "12px" },
                    margin: { xs: 0, sm: "32px" },
                    width: { xs: "100%", sm: "auto" },
                },
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: { xs: "18px", sm: "20px" },
                    fontWeight: 600,
                    pb: 1.5,
                    borderBottom: "1px solid #e0e0e0",
                }}
            >
                Confirm
            </DialogTitle>

            <DialogContent
                sx={{
                    pt: 3,
                    pb: 3,
                    px: { xs: 2, sm: 3 },
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography variant="body1" component="div">
                        {props.text}
                    </Typography>
                    {props.line && (
                        <Typography
                            variant="body1"
                            component="p"
                            sx={{ fontWeight: 600 }}
                        >
                            {props.line}
                        </Typography>
                    )}
                    {props.id && (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 1, fontSize: "0.875rem" }}
                        >
                            {props.id}
                        </Typography>
                    )}
                </Box>
            </DialogContent>

            <DialogActions
                sx={{
                    px: { xs: 2, sm: 3 },
                    pb: { xs: 2, sm: 2.5 },
                    pt: 2,
                    borderTop: "1px solid #e0e0e0",
                    gap: { xs: 1, sm: 1.5 },
                    flexDirection: { xs: "column", sm: "row" },
                }}
            >
                <Button
                    onClick={close_handler}
                    variant="outlined"
                    color="error"
                    sx={{
                        width: { xs: "100%", sm: "auto" },
                        minWidth: { xs: "100%", sm: 120 },
                        height: { xs: "48px", sm: "auto" },
                        order: { xs: 2, sm: 2 },
                    }}
                >
                    Back
                </Button>
                <Button
                    onClick={delete_handler}
                    variant="contained"
                    color="error"
                    sx={{
                        width: { xs: "100%", sm: "auto" },
                        minWidth: { xs: "100%", sm: 120 },
                        height: { xs: "48px", sm: "auto" },
                        fontWeight: 600,
                        order: { xs: 1, sm: 1 },
                        boxShadow: "0 4px 12px rgba(211, 47, 47, 0.3)",
                        "&:hover": {
                            boxShadow: "0 6px 16px rgba(211, 47, 47, 0.4)",
                        },
                    }}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default YesNo_modal;
